import appData from "@/data/app.json";
import type { Lang } from "./types";

export const APP = appData;
export const CDN = appData.domain.cdn;
export const BRAND_ID = appData.brand.id;
export const ACTIVE_LANGS = appData.activeLangs as Lang[];
export const DEFAULT_LANG: Lang = "sv";
export const CONTACT_EMAIL = appData.email.contact;
export const CONTACT_PHONE = appData.phone;
